import MaterialIcon from '@components/common/MaterialIcon';
import type { TMaterialIconType } from '@interfaces/IGeneral';
import clsx from 'clsx';
import type React from 'react';
import type { FieldValues } from 'react-hook-form';
import LabelT from '../Label/LabelT';

type ButtonIconTProps<_T extends FieldValues> = {
  icon: string;
  iconType?: TMaterialIconType;
  color?: string;
  onClick?: () => void;
  label?: string;
  id?: string;
  labelClassName?: string;
  iconSize?: string;
  iconClassName?: string;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export function ButtonIconT<T extends FieldValues>({
  icon,
  color = '',
  iconType,
  onClick,
  label,
  id,
  style,
  labelClassName = '',
  iconSize = '2xl',
  iconClassName = '',
  tooltip,
  tooltipPosition,
  ...restParams
}: ButtonIconTProps<T>) {
  const { className, disabled } = restParams;

  const defaultStyles = [
    'gap-1',
    'flex',
    'items-center',
    'cursor-pointer',
    'text-xs',
    'w-fit',
    'select-none',
    disabled ? 'opacity-50 cursor-default' : '',
  ];

  if (label) {
    defaultStyles.push(
      'border',
      `border-${color}`,
      'rounded-full',
      'py-1',
      'px-2',
    );
  } else {
    defaultStyles.push('px-2');
  }

  return (
    <div className={clsx([...defaultStyles, className])} onClick={onClick}>
      <MaterialIcon
        icon={icon}
        type={iconType}
        classes={[
          `text-${color}`,
          `text-${iconSize}`,
          '!leading-none',
          iconClassName,
        ]}
        tooltip={tooltip}
        tooltipPosition={tooltipPosition}
      />
      {label && <LabelT text={label} id={id} className={labelClassName} />}
    </div>
  );
}

export default ButtonIconT;
